const addScrollParam = (url: string, scrollId: string): string => {
  const [path, query = ''] = url.split('?');
  const params = new URLSearchParams(query);
  params.set('scroll', scrollId);
  return `${path}?${params.toString()}`;
};


export default addScrollParam;